import { render, staticRenderFns } from "./schoolReviewDetail.vue?vue&type=template&id=1fbbcbdb&scoped=true&"
import script from "./schoolReviewDetail.vue?vue&type=script&lang=js&"
export * from "./schoolReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./schoolReviewDetail.vue?vue&type=style&index=0&id=1fbbcbdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbbcbdb",
  null
  
)

export default component.exports